import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import appMessages from '~/containers/App/messages';
import MenuItem from '@mui/material/MenuItem';

import messages from './messages';
import { shiftsScaffold } from '~/generated';
import { extractData } from '~/utils/query-utils';

type ImportShiftsMenuItemProps = {
  templateRange: { week: number; year: number };
  targetRange: { week: number; year: number };
  onCloseMenu: () => void;
};

const ImportShiftsMenuItem = (props: ImportShiftsMenuItemProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const mutation = useMutation({
    mutationKey: ['shifts', 'import'],
    mutationFn() {
      return extractData(
        shiftsScaffold({
          body: {
            targetRange: props.targetRange,
            templateRange: props.templateRange,
          },
        })
      );
    },
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.importShiftsSuccess),
      });
      props.onCloseMenu();
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.importShiftsFailure),
      });
      props.onCloseMenu();
    },
  });
  return (
    <MenuItem disabled={mutation.isPending} onClick={() => mutation.mutate()}>
      {mutation.isPending
        ? intl.formatMessage(appMessages.loading)
        : intl.formatMessage(messages.importShifts)}
    </MenuItem>
  );
};

export default ImportShiftsMenuItem;
